import CreateHookView from "@features/tools/view/hooks-view/create-hook-view";

const CreateHooks = () => {
  return <CreateHookView />;
};

export default CreateHooks;
